const symbolRegistry = {
  pump: {
    id: "pump",
    label: "Pump",
    render: ({ selected = false }) => null,
  },

  valve: {
    id: "valve",
    label: "Valve",
    render: ({ selected = false }) => null,
  },

  electricalPanel: {
    id: "electricalPanel",
    label: "Electrical Panel",
    render: ({ selected = false }) => null,
  },
};

export default symbolRegistry;